import { piniaOfficeOffer } from '@stores/office-offer';
import { createApp } from 'vue';
import CombinatorChoose from './CombinatorChoose.vue';

export const initCombinatorChoose = () => {
  if (!document.getElementById('combinator-choose-app')) {
    return;
  }

  const app = createApp(CombinatorChoose);

  app.use(piniaOfficeOffer);
  app.mount('#combinator-choose-app');
};
